import { Selector, SelectorGroup } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import { UseFormMethods } from 'react-hook-form'
import { useId } from 'react-id-generator'
import styled from 'styled-components'

import { ItemSelectorOptionLabelForPaymentTiming, PriceLabelPrice } from './ItemSelectorOptionLabel'

const StyledSelectorGroup = styled(SelectorGroup)`
  margin-bottom: 0;
  flex: 1 0 100%;
  ${Selector} {
    width: 100%;
    max-width: 50%;
    label {
      justify-content: center;
      flex-wrap: wrap;
      border: 1px solid #d9d9d9;
      background-color: #faf9f9;
      color: ${({ theme }) => theme.colors.grayscale.black};
      font-family: ${({ theme }) => theme.fontFamilies.gotham};
      padding-left: 0;
      padding-right: 0;
    }
    input:checked + label {
      border: 2px solid ${({ theme }) => theme.colors.grayscale.black};
      ${PriceLabelPrice} {
        background-color: ${({ theme }) => theme.colors.grayscale.black};
        color: white;
      }
    }
  }
`

export interface PaymentTimingOptionsProps {
  register: UseFormMethods['register']
  payUpfrontPrice: number
  payUpfrontOptionValue: string
}

const PaymentTimingOptions: FC<PaymentTimingOptionsProps> = ({
  register,
  payUpfrontPrice,
  payUpfrontOptionValue,
}) => {
  const attribute = 'price'
  const ids = useId(2, `${attribute}-`)

  return (
    <div className="item-control">
      <div className="control-header robotoCondensed">{attribute}</div>
      <StyledSelectorGroup
        name="pay_upfront_option_value"
        register={register}
        selectorOptions={[
          {
            id: `${ids[0]}`,
            label: (
              <ItemSelectorOptionLabelForPaymentTiming
                label={'Pay later'}
                price={0}
                priceAside="Now"
              />
            ),
            value: undefined,
          },
          {
            id: `${ids[1]}`,
            label: (
              <ItemSelectorOptionLabelForPaymentTiming
                label={'Pay upfront'}
                price={payUpfrontPrice}
              />
            ),
            value: payUpfrontOptionValue,
          },
        ]}
      />
    </div>
  )
}

export default PaymentTimingOptions
